import { z } from 'zod';

import { FormValidation } from '@/_shared';

export const personalInfoCheckoutFormSchemaRaw = z.object({
  first_name: z.string().min(2),
  last_name: z.string().min(2),
  email: FormValidation.email,
  phone: FormValidation.mobilePhone,
  state: FormValidation.selectInput(),
  zip_code: FormValidation.requiredString,
  password: z.string().min(8),
  confirm_password: z.string().min(8),
});

export const personalInfoCheckoutFormSchema = personalInfoCheckoutFormSchemaRaw.refine(
  (data) => data.confirm_password === data.confirm_password,
  {
    message: 'The new password fields do not match',
    path: ['confirm_password'],
  }
);
// .refine((data) => data.password !== data.confirm_password, {
//   message: 'New password must be different from the current password',
//   path: ['password'],
// });

export type PersonalInfoCheckoutFormSchema = z.infer<typeof personalInfoCheckoutFormSchema>;
